import React from 'react'
import { withIcon } from '../../withIcon'

function AddPlaylistOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M6.45166 6.07692H20.3333C20.6402 6.07692 20.8889 6.318 20.8889 6.61539V14.6853C21.5136 14.6202 22 14.1075 22 13.4847V6.20758C22 5.54065 21.4422 5 20.7541 5H7.69037C7.04781 5 6.51887 5.47145 6.45166 6.07692Z" fill={color}/>
      <path d="M19.7778 8.36143C19.7778 7.6945 19.22 7.15385 18.5319 7.15385H5.46814C4.82558 7.15385 4.29664 7.6253 4.22943 8.23077H18.1111C18.4179 8.23077 18.6667 8.47185 18.6667 8.76924V16.8392C19.2914 16.774 19.7778 16.2614 19.7778 15.6386L19.7778 8.36143Z" fill={color}/>
      <path fillRule="evenodd" clipRule="evenodd" d="M16.3096 10.5153H3.24591L3.24591 17.7924L16.3096 17.7924L16.3096 10.5153ZM3.24591 9.30768C2.55781 9.30768 2 9.84833 2 10.5153V17.7924C2 18.4593 2.55781 19 3.24591 19H16.3096C16.9977 19 17.5555 18.4593 17.5555 17.7924V10.5153C17.5555 9.84833 16.9977 9.30768 16.3096 9.30768H3.24591Z" fill={color}/>
      <path d="M9.3192 11.8604C9.3192 11.5431 9.57645 11.2859 9.89378 11.2859C10.2111 11.2859 10.4684 11.5431 10.4684 11.8604V16.4571C10.4684 16.7744 10.2111 17.0317 9.89378 17.0317C9.57645 17.0317 9.3192 16.7744 9.3192 16.4571V11.8604Z" fill={color}/>
      <path d="M7.59546 14.7333C7.27812 14.7333 7.02087 14.4761 7.02087 14.1588C7.02087 13.8414 7.27812 13.5842 7.59546 13.5842L12.1921 13.5842C12.5094 13.5842 12.7667 13.8414 12.7667 14.1588C12.7667 14.4761 12.5094 14.7333 12.1921 14.7333L7.59546 14.7333Z" fill={color}/>
    </svg>
  )
}

export default withIcon(AddPlaylistOutlineIcon)
